import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9b0bfa9c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0bfa9c')) {
      api.createRecord('9b0bfa9c', component.options)
    } else {
      api.reload('9b0bfa9c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9b0bfa9c&", function () {
      api.rerender('9b0bfa9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pa1WkCBA2IWo/JS/offershelp.vue"
export default component.exports